module.exports = __webpack_public_path__ + "img/110.856f4807.jpg";